function normalizeGroup(value) {
  return String(value || '').trim().toLowerCase()
}

function getNormalizedGroups(user) {
  return Array.isArray(user?.groups) ? user.groups.map(normalizeGroup) : []
}

export function isSalesAgentUser(user) {
  if (!user) return false
  if (user.role === 'ops_admin' || user.role === 'ops_vp' || user.role === 'ops_sales_vp') {
    return false
  }

  const groups = getNormalizedGroups(user)
  return user.role === 'sales_agent' || groups.includes('sales_agent') || groups.includes('sales')
}

export function getDefaultViewForUser(user) {
  return isSalesAgentUser(user) ? 'sales' : 'dashboard'
}

export function canAccessView(user, view) {
  const nextView = String(view || '').trim()
  if (!nextView) return true
  if (!isSalesAgentUser(user)) return true
  return nextView === 'sales'
}

export function coerceViewForUser(user, view) {
  const requestedView = String(view || '').trim()
  if (requestedView && canAccessView(user, requestedView)) {
    return requestedView
  }
  return getDefaultViewForUser(user)
}
